import { render, staticRenderFns } from "./TheButton.vue?vue&type=template&id=280c52ff&scoped=true"
import script from "./TheButton.vue?vue&type=script&lang=js"
export * from "./TheButton.vue?vue&type=script&lang=js"
import style0 from "./TheButton.vue?vue&type=style&index=0&id=280c52ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c52ff",
  null
  
)

export default component.exports